import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home, Shop, NotFound } from './screens';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop/:shop_id" element={<Shop />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

